(function () {
  var aliaLoaded = false;
  var acsbLoaded = false;
  function inject(src) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.defer = true;
    document.body.appendChild(s);
  }
  function loadAlia() {
    if (aliaLoaded) return;
    aliaLoaded = true;
    inject('https://backend.alia-prod.com/public/launcher.js?shopifyUrl=reach-international-outfitters.myshopify.com');
  }
  function loadAcsb() {
    if (acsbLoaded) return;
    acsbLoaded = true;
    inject('https://acsbapp.com/apps/app/dist/js/app.js');
  }
  function onLoad() {
    loadAlia();
    setTimeout(loadAcsb, 4000);
  }
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, loadAcsb, { once: true, passive: true });
  });
  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad, { once: true });
  }
})();
